// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  location: 'qa',
  API_URL: 'https://localhost:7240',
  //API_URL: 'https://qnbn-apim-vp-dv-we.azure-api.net/vp',
  APIM_SUBSCRIPTION_KEY: 'a9ca3ad62bd84a4ca38cff4916ef62ae',
  //API_URL: 'https://qnbn-app-tca-be-dv-we-01-c5b5chg0hug6dzbd.westeurope-01.azurewebsites.net',
  APIs_PREFIX: 'api',
  pageSize: 5,
  DISABLE_BACKEND: true, // Demo mode: every backend request is served locally
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
